module.exports = __webpack_public_path__ + "img/Event3.610c1c40.jpg";